module.exports = __webpack_public_path__ + "static/media/Oedipus.c1bcfd05.jpg";